import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  StyledTitleAndLinkWrapper,
  StyledShowAll,
  StyledOuterWrapper,
} from './styles'
import { If } from '../if'
import { Text, Title } from '../text'
import { useTranslation } from '../../../context/translationProvider'
import { CarouselHeaderFallback } from './fallback'
import { AuthContext } from '../../../context/authProvider'
import { useSEOContentVisibility } from '../../../hooks/useSEOContentVisibility'
import {
  normalizeDataLayerText,
  pushDataLayer,
} from '../../../utils/pushDataLayer'

const CarouselHeader = (props) => {
  const { translate } = useTranslation()
  const {
    title,
    href,
    customTrailingElement,
    description,
    titleTag,
    hideDescriptionOnLoggedIn,
    screenName,
    triggerGAEvent,
  } = props
  const { showSEOContent } = useSEOContentVisibility()

  const { isLoggedIn } = useContext(AuthContext)
  const hideDescription =
    !hideDescriptionOnLoggedIn || isLoggedIn || !showSEOContent

  const onShowAllClick = () => {
    if (triggerGAEvent) {
      pushDataLayer({
        eventName: 'carousel-show-all',
        data: {
          location: screenName,
          category_name: normalizeDataLayerText(title),
        },
      })
    }
  }

  if (!title) return <CarouselHeaderFallback />

  return (
    <StyledOuterWrapper>
      <StyledTitleAndLinkWrapper>
        <Title level={2} tagType={titleTag}>
          {title}
        </Title>

        <If
          condition={!!customTrailingElement}
          render={customTrailingElement}
          renderElse={() => (
            <If
              condition={!!href}
              render={() => (
                <StyledShowAll
                  to={href}
                  id="casino-carousel-show-all"
                  onClick={onShowAllClick}
                >
                  {translate('common.showAll')}
                </StyledShowAll>
              )}
            />
          )}
        />
      </StyledTitleAndLinkWrapper>
      <If
        condition={description && !hideDescription}
        render={() => <Text>{description}</Text>}
      />
    </StyledOuterWrapper>
  )
}

CarouselHeader.defaultProps = {
  title: '',
  href: '',
  description: '',
  titleTag: 'h2',
  customTrailingElement: null,
  hideDescriptionOnLoggedIn: false,
}

CarouselHeader.propTypes = {
  title: PropTypes.string,
  href: PropTypes.string,
  description: PropTypes.string,
  titleTag: PropTypes.string,
  customTrailingElement: PropTypes.func,
  hideDescriptionOnLoggedIn: PropTypes.bool,
  screenName: PropTypes.string,
  triggerGAEvent: PropTypes.bool,
}

export { CarouselHeader }
